import React, {Component} from 'react';
import {connect} from 'react-redux';
import ActiveIndicatorMessage from '../components/ActiveIndicatorMessage';
import LoadingMessage from '../containers/LoadingMessage';
import CentreMessages from './CentreMessages';
import Footer from './Footer';
import GrowlerMessages from './GrowlerMessages';
import MapLayers from './MapLayers';
import PointGraphs from './PointGraphs';

class Content extends Component {
  render() {
    const { indicators, time } = this.props;
    const active_indicator = indicators.active;
    return (<div className="content">
        <div className="map-container">
          <GrowlerMessages/>
          <CentreMessages/>
          <LoadingMessage/>
          <ActiveIndicatorMessage active_indicator={active_indicator} time={time}/>
          <MapLayers/>
          <Footer/>
        </div>
        <PointGraphs/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    indicators: state.indicators,
    time: state.time
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

Content = connect(mapStateToProps, mapDispatchToProps)(Content);

export default Content;


// WEBPACK FOOTER //
// ./src/containers/Content.js